/* eslint-disable indent */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */

import { Dispatch } from 'redux';
import { ICartBenefit } from 'src/interfaces';

import benefitsService from 'src/services/benefits.service';

import { AlertAdapter } from 'pg-ui-library';

import { BenefitsActionType } from '../action-types';
import { BenefitsAction } from '../actions';
import { RootState } from '../reducers';
import { EnrollmentTypes } from '../reducers/benefitsReducer';

export const getBenefits = () => async (dispatch: Dispatch<BenefitsAction>) => {
  dispatch({
    type: BenefitsActionType.GET_BENEFITS,
  });

  try {
    // eslint-disable-next-line max-len
    const response = await benefitsService.getBenefits();
    const {
      employeeCurrentBenefits,
      employeeLastBenefitDto,
      totalDeduction,
      isEnrollmentOpen,
      isNewHire,
      isQle,
      isBenefitUpdate,
      isOpenEnrollment,
      daysToEndMonth,
      categoriesToElect,
      freePlansAvailable,
    } = response;
    dispatch({
      type: BenefitsActionType.GET_BENEFITS_SUCCESS,
      payload: {
        benefits: employeeCurrentBenefits,
        employeeLastBenefitDto,
        totalDeduction,
        isEnrollmentOpen,
        isNewHire,
        isQle,
        isBenefitUpdate,
        isOpenEnrollment,
        daysToEndMonth,
        categoriesToElect,
        freePlansAvailable,
      },
    });
  } catch (err: any) {
    dispatch({
      type: BenefitsActionType.GET_BENEFITS_FAILURE,
      payload: err.message,
    });
  }
};

export const getCartSession =
  (eventType?: EnrollmentTypes) => async (dispatch: Dispatch<BenefitsAction>, getState: () => RootState) => {
    dispatch({
      type: BenefitsActionType.GET_CART_SESSION,
    });

    try {
      const currentEnrollmentType = eventType || getState().benefits.data.enrollmentType;
      const { cartBody } = await benefitsService.getCartSession(currentEnrollmentType);

      dispatch({
        type: BenefitsActionType.GET_CART_SESSION_SUCCESS,
        payload: cartBody,
      });
    } catch (err: any) {
      dispatch({
        type: BenefitsActionType.GET_CART_SESSION_FAILURE,
        payload: err.message,
      });
    }
  };

export const addBenefitToCart =
  (benefits: ICartBenefit[] | ICartBenefit) =>
  async (dispatch: Dispatch<BenefitsAction>, getState: () => RootState) => {
    if (Array.isArray(benefits)) {
      benefits.forEach(benefit => {
        dispatch({
          type: BenefitsActionType.ADD_BENEFIT_TO_CART,
          payload: { benefit },
        });
      });
    } else {
      dispatch({
        type: BenefitsActionType.ADD_BENEFIT_TO_CART,
        payload: { benefit: benefits as ICartBenefit },
      });
    }

    const updatedState = getState().benefits.data.cart;
    const currentEnrollmentType = getState().benefits.data.enrollmentType;

    try {
      dispatch({
        type: BenefitsActionType.UPDATE_CART_SESSION,
      });

      await benefitsService.updateCartSession(updatedState || [], currentEnrollmentType);

      dispatch({
        type: BenefitsActionType.UPDATE_CART_SESSION_SUCCESS,
      });
    } catch (err: any) {
      AlertAdapter('Failed to update benefits from cart', 'warning');
      dispatch({
        type: BenefitsActionType.UPDATE_CART_SESSION_FAILURE,
        payload: err.message,
      });
    }
  };

export const removeBenefitFromCart =
  (benefit: ICartBenefit) => async (dispatch: Dispatch<BenefitsAction>, getState: () => RootState) => {
    dispatch({
      type: BenefitsActionType.REMOVE_BENEFIT_FROM_CART,
      payload: { benefit },
    });
    const updatedState = getState().benefits.data.cart;
    const currentEnrollmentType = getState().benefits.data.enrollmentType;

    try {
      dispatch({
        type: BenefitsActionType.UPDATE_CART_SESSION,
      });

      await benefitsService.updateCartSession(updatedState || [], currentEnrollmentType);

      dispatch({
        type: BenefitsActionType.UPDATE_CART_SESSION_SUCCESS,
      });
    } catch (err: any) {
      AlertAdapter('Failed to update benefits from cart', 'warning');
      dispatch({
        type: BenefitsActionType.UPDATE_CART_SESSION_FAILURE,
        payload: err.message,
      });
    }
  };

export const clearCart = () => async (dispatch: Dispatch<BenefitsAction>, getState: () => RootState) => {
  const currentEnrollmentType = getState().benefits.data.enrollmentType;
  try {
    dispatch({
      type: BenefitsActionType.UPDATE_CART_SESSION,
    });

    await benefitsService.updateCartSession([], currentEnrollmentType);

    dispatch({
      type: BenefitsActionType.UPDATE_CART_SESSION_SUCCESS,
    });

    dispatch({
      type: BenefitsActionType.CLEAR_BENEFITS_FROM_CART,
      payload: { cart: [] },
    });
  } catch (err: any) {
    AlertAdapter('Failed to update benefits from cart', 'warning');
    dispatch({
      type: BenefitsActionType.UPDATE_CART_SESSION_FAILURE,
      payload: err.message,
    });
  }
};

export const setBenefitEnrollmentType = (type: EnrollmentTypes) => async (dispatch: Dispatch<BenefitsAction>) => {
  dispatch({
    type: BenefitsActionType.SET_ENROLLMENT_TYPE,
    payload: type,
  });
};

export const setQLEFiles = (files: unknown[]) => async (dispatch: Dispatch<BenefitsAction>) => {
  dispatch({
    type: BenefitsActionType.SET_QLE_FILES,
    payload: files,
  });
};
